const BLACKLIST = [
  'gamil.com',
  'gemail.com',
  'gmai.com',
  'gamail.com',
  'msm.com',
  'gmal.com',
  'gmil.com',
  'xmail.com',
  'homail.com',
  'gmaill.com',
  'gmial.com',
  'hotamil.com',
  'gimail.com',
  'outlouk.com',
  'zoho.com',
  'freemail.hu',
  'poczta.onet.pl',
  'hotmai.com',
  'bbox.com',
  'hotmal.com',
  'gmaiil.com',
  'wanadoo.com',
  'a.com',
  'oulook.com',
  '02.pl',
  'yopmail.com',
  'e-mail.com',
  'gmail.net',
  'outlok.com',
  'htmail.com',
  'lgmail.com',
  'dr.com',
  'hotmaill.com',
  'yaho.com',
  'qmail.com',
  'gnail.com',
  '99.com',
  'gmx.es',
  'consultant.com',
  '1gmail.com',
  'autlook.com',
  'cmail.com',
  'otmail.com',
  'ggmail.com',
  'hatmail.com',
  'spamgourmet.com',
  'hush.com',
  'hotail.com',
  'outloo.com',
  'gmails.com',
  'hotmial.com',
  'i.ua',
  'myself.com',
  'yahooo.com',
  'test.com',
  'agmail.com',
  'safe-mail.net',
  'yeah.net',
  'gotmail.com',
  'opayq.com',
  'gmaik.com',
  'igmail.com',
  'sohu.com',
  'writeme.com',
  'royal.net',
  '139.com',
  'game.com',
  'gmall.com',
  'xl.cx',
  'latinmail.com',
  'unseen.is',
  'xoxy.net',
  'hotmali.com',
  'vistomail.com',
  'fastservice.com',
  'tmail.com',
  'amail.com',
  'vmail.me',
  'aoll.com',
  'geail.com',
  'iymail.com',
  'lavabit.com',
  'mail2world.com',
  'mail333.com',
  'nokiamail.com',
  'ymai.com',
  'yopmail.fr',
  '51.com',
  'dfgh.net',
  'email.net',
  'mmail.com',
  'proxymail.eu',
  'contractor.net',
  'vfemail.net',
  'yahoo.us',
  '123gmail.com',
  'bluebottle.com',
  'mindless.com',
  'ogmail.com',
  'yotmail.com',
  '1hotmail.com',
  '52gmail.com',
  'example.com',
  'jamel.com',
  'neverbox.com',
  'obmail.com',
  'poczta.pl',
  '0-mail.com',
  'gmeail.com',
  'jetable.org',
  'mailhaven.com',
  'nus.edu.sg',
  'objectmail.com',
  '555gmail.com',
  'aolo.com',
  'gmaeil.com',
  'jupimail.com',
  'mac.hush.com',
  'mailinator.com',
  'mails.com',
  'priest.com',
  'sify.com',
  'zhorachu.com',
  'carmail.com',
  'gmasil.com',
  'hush.ai',
  'msgden.com',
  'mssn.com',
  'ohmail.com',
  'techemail.com',
  'yahoo.cu.uk',
  'yahu.com',
  '188.com',
  'a-bc.net',
  'dumail.com',
  'ebmail.com',
  'e-mail.net',
  'emil.com',
  'femail.com',
  'gawab.com',
  'hdmail.com',
  'hoo.com',
  'inboxhub.net',
  'jetable.com',
  'mail15.com',
  'mail2tor.com',
  'mailplus.pl',
  'mail-temporaire.fr',
  'mson.com',
  'notsharingmy.info',
  'onet.com',
  'otlook.es',
  'snkmail.com',
  'spamgourmet.org',
  'tom.com',
  'topmail.com',
  'tormail.org',
  'trashmail.net',
  'usako.net',
  'yoo.com',
]

export default BLACKLIST
